// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PasswordExpiredRouteImport } from './routes/password-expired'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthLogoutRouteImport } from './routes/_auth/logout'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as Dashboard401RouteImport } from './routes/_dashboard/401'
import { Route as DashboardUsersRouteRouteImport } from './routes/_dashboard/users/route'
import { Route as DashboardUserLabelsRouteRouteImport } from './routes/_dashboard/user-labels/route'
import { Route as DashboardSettingsRouteRouteImport } from './routes/_dashboard/settings/route'
import { Route as DashboardQueuesRouteRouteImport } from './routes/_dashboard/queues/route'
import { Route as DashboardQueueGroupsRouteRouteImport } from './routes/_dashboard/queue-groups/route'
import { Route as DashboardOrganisationsRouteRouteImport } from './routes/_dashboard/organisations/route'
import { Route as DashboardLicencesRouteRouteImport } from './routes/_dashboard/licences/route'
import { Route as DashboardIvrRouteRouteImport } from './routes/_dashboard/ivr/route'
import { Route as DashboardGatewaysRouteRouteImport } from './routes/_dashboard/gateways/route'
import { Route as DashboardEmailsRouteRouteImport } from './routes/_dashboard/emails/route'
import { Route as DashboardDivergencesRouteRouteImport } from './routes/_dashboard/divergences/route'
import { Route as DashboardClientManagementRouteRouteImport } from './routes/_dashboard/client-management/route'
import { Route as DashboardCallscreeningRouteRouteImport } from './routes/_dashboard/callscreening/route'
import { Route as DashboardBusinessDirectoryRouteRouteImport } from './routes/_dashboard/business-directory/route'
import { Route as DashboardAdministratorsRouteRouteImport } from './routes/_dashboard/administrators/route'
import { Route as DashboardQueuesNewQueueRouteImport } from './routes/_dashboard/queues/new-queue'
import { Route as DashboardQueuesQueueIdRouteRouteImport } from './routes/_dashboard/queues/$queueId/route'
import { Route as DashboardQueueGroupsNewGroupRouteImport } from './routes/_dashboard/queue-groups/new-group'
import { Route as DashboardQueueGroupsQueueGroupIdRouteRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/route'
import { Route as DashboardOrganisationsNewOrgRouteImport } from './routes/_dashboard/organisations/new-org'
import { Route as DashboardOrganisationsOrgIdRouteRouteImport } from './routes/_dashboard/organisations/$orgId/route'
import { Route as DashboardIvrNewIvrRouteImport } from './routes/_dashboard/ivr/new-ivr'
import { Route as DashboardIvrIvrIdRouteRouteImport } from './routes/_dashboard/ivr/$ivrId/route'
import { Route as DashboardEmailsSystemRouteRouteImport } from './routes/_dashboard/emails/system/route'
import { Route as DashboardEmailsOrganisationsRouteRouteImport } from './routes/_dashboard/emails/organisations/route'
import { Route as DashboardCallscreeningSystemRouteImport } from './routes/_dashboard/callscreening/system'
import { Route as DashboardCallscreeningQueuesRouteRouteImport } from './routes/_dashboard/callscreening/queues/route'
import { Route as DashboardCallscreeningOrganisationsRouteRouteImport } from './routes/_dashboard/callscreening/organisations/route'
import { Route as DashboardBusinessDirectoryTypesRouteRouteImport } from './routes/_dashboard/business-directory/types/route'
import { Route as DashboardBusinessDirectoryCategoriesRouteRouteImport } from './routes/_dashboard/business-directory/categories/route'
import { Route as DashboardBusinessDirectoryBusinessesRouteRouteImport } from './routes/_dashboard/business-directory/businesses/route'
import { Route as DashboardAdministratorsProfilesRouteRouteImport } from './routes/_dashboard/administrators/profiles/route'
import { Route as DashboardAdministratorsAccountsRouteRouteImport } from './routes/_dashboard/administrators/accounts/route'
import { Route as DashboardQueuesQueueIdSettingsRouteImport } from './routes/_dashboard/queues/$queueId/settings'
import { Route as DashboardQueuesQueueIdEditRouteImport } from './routes/_dashboard/queues/$queueId/edit'
import { Route as DashboardQueuesQueueIdCallScreeningRouteImport } from './routes/_dashboard/queues/$queueId/call-screening'
import { Route as DashboardQueuesQueueIdAgentsRouteImport } from './routes/_dashboard/queues/$queueId/agents'
import { Route as DashboardQueueGroupsQueueGroupIdQueuesRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/queues'
import { Route as DashboardQueueGroupsQueueGroupIdEditRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/edit'
import { Route as DashboardQueueGroupsQueueGroupIdAgentsRouteImport } from './routes/_dashboard/queue-groups/$queueGroupId/agents'
import { Route as DashboardOrganisationsOrgIdRenameRouteImport } from './routes/_dashboard/organisations/$orgId/rename'
import { Route as DashboardOrganisationsOrgIdPredefinedTextsRouteImport } from './routes/_dashboard/organisations/$orgId/predefined-texts'
import { Route as DashboardOrganisationsOrgIdUsersRouteRouteImport } from './routes/_dashboard/organisations/$orgId/users/route'
import { Route as DashboardOrganisationsOrgIdUserLabelsRouteRouteImport } from './routes/_dashboard/organisations/$orgId/user-labels/route'
import { Route as DashboardOrganisationsOrgIdSettingsRouteRouteImport } from './routes/_dashboard/organisations/$orgId/settings/route'
import { Route as DashboardOrganisationsOrgIdContactListRouteRouteImport } from './routes/_dashboard/organisations/$orgId/contact-list/route'
import { Route as DashboardOrganisationsOrgIdCallScreeningRouteRouteImport } from './routes/_dashboard/organisations/$orgId/call-screening/route'
import { Route as DashboardIvrIvrIdIndexRouteImport } from './routes/_dashboard/ivr/$ivrId/index'
import { Route as DashboardEmailsSystemIndexRouteImport } from './routes/_dashboard/emails/system/index'
import { Route as DashboardEmailsSystemNewEmailRouteImport } from './routes/_dashboard/emails/system/new-email'
import { Route as DashboardEmailsOrganisationsNewEmailRouteImport } from './routes/_dashboard/emails/organisations/new-email'
import { Route as DashboardEmailsOrganisationsOrgIdRouteRouteImport } from './routes/_dashboard/emails/organisations/$orgId/route'
import { Route as DashboardCallscreeningQueuesQueueIdRouteImport } from './routes/_dashboard/callscreening/queues/$queueId'
import { Route as DashboardCallscreeningOrganisationsOrgIdRouteImport } from './routes/_dashboard/callscreening/organisations/$orgId'
import { Route as DashboardBusinessDirectoryTypesIndexRouteImport } from './routes/_dashboard/business-directory/types/index'
import { Route as DashboardBusinessDirectoryCategoriesIndexRouteImport } from './routes/_dashboard/business-directory/categories/index'
import { Route as DashboardBusinessDirectoryBusinessesIndexRouteImport } from './routes/_dashboard/business-directory/businesses/index'
import { Route as DashboardBusinessDirectoryBusinessesRouteNewRouteImport } from './routes/_dashboard/business-directory/businesses/route-new'
import { Route as DashboardBusinessDirectoryBusinessesOrganisationsRouteRouteImport } from './routes/_dashboard/business-directory/businesses/organisations/route'
import { Route as DashboardOrganisationsOrgIdEmailsIndexRouteImport } from './routes/_dashboard/organisations/$orgId/emails/index'
import { Route as DashboardOrganisationsOrgIdEmailsNewEmailRouteImport } from './routes/_dashboard/organisations/$orgId/emails/new-email'
import { Route as DashboardEmailsOrganisationsOrgIdIndexRouteImport } from './routes/_dashboard/emails/organisations/$orgId/index'
import { Route as DashboardEmailsOrganisationsOrgIdNewEmailRouteImport } from './routes/_dashboard/emails/organisations/$orgId/new-email'

const PasswordExpiredRoute = PasswordExpiredRouteImport.update({
            id: '/password-expired',path: '/password-expired',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/_auth/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/_auth/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const Dashboard401Route = Dashboard401RouteImport.update({
            id: '/401',path: '/401',getParentRoute: () => DashboardRouteRoute
          })
const DashboardUsersRouteRoute = DashboardUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => DashboardRouteRoute
          })
const DashboardUserLabelsRouteRoute = DashboardUserLabelsRouteRouteImport.update({
            id: '/user-labels',path: '/user-labels',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueuesRouteRoute = DashboardQueuesRouteRouteImport.update({
            id: '/queues',path: '/queues',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueueGroupsRouteRoute = DashboardQueueGroupsRouteRouteImport.update({
            id: '/queue-groups',path: '/queue-groups',getParentRoute: () => DashboardRouteRoute
          })
const DashboardOrganisationsRouteRoute = DashboardOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardRouteRoute
          })
const DashboardLicencesRouteRoute = DashboardLicencesRouteRouteImport.update({
            id: '/licences',path: '/licences',getParentRoute: () => DashboardRouteRoute
          })
const DashboardIvrRouteRoute = DashboardIvrRouteRouteImport.update({
            id: '/ivr',path: '/ivr',getParentRoute: () => DashboardRouteRoute
          })
const DashboardGatewaysRouteRoute = DashboardGatewaysRouteRouteImport.update({
            id: '/gateways',path: '/gateways',getParentRoute: () => DashboardRouteRoute
          })
const DashboardEmailsRouteRoute = DashboardEmailsRouteRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => DashboardRouteRoute
          })
const DashboardDivergencesRouteRoute = DashboardDivergencesRouteRouteImport.update({
            id: '/divergences',path: '/divergences',getParentRoute: () => DashboardRouteRoute
          })
const DashboardClientManagementRouteRoute = DashboardClientManagementRouteRouteImport.update({
            id: '/client-management',path: '/client-management',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCallscreeningRouteRoute = DashboardCallscreeningRouteRouteImport.update({
            id: '/callscreening',path: '/callscreening',getParentRoute: () => DashboardRouteRoute
          })
const DashboardBusinessDirectoryRouteRoute = DashboardBusinessDirectoryRouteRouteImport.update({
            id: '/business-directory',path: '/business-directory',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAdministratorsRouteRoute = DashboardAdministratorsRouteRouteImport.update({
            id: '/administrators',path: '/administrators',getParentRoute: () => DashboardRouteRoute
          })
const DashboardQueuesNewQueueRoute = DashboardQueuesNewQueueRouteImport.update({
            id: '/new-queue',path: '/new-queue',getParentRoute: () => DashboardQueuesRouteRoute
          })
const DashboardQueuesQueueIdRouteRoute = DashboardQueuesQueueIdRouteRouteImport.update({
            id: '/$queueId',path: '/$queueId',getParentRoute: () => DashboardQueuesRouteRoute
          })
const DashboardQueueGroupsNewGroupRoute = DashboardQueueGroupsNewGroupRouteImport.update({
            id: '/new-group',path: '/new-group',getParentRoute: () => DashboardQueueGroupsRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdRouteRoute = DashboardQueueGroupsQueueGroupIdRouteRouteImport.update({
            id: '/$queueGroupId',path: '/$queueGroupId',getParentRoute: () => DashboardQueueGroupsRouteRoute
          })
const DashboardOrganisationsNewOrgRoute = DashboardOrganisationsNewOrgRouteImport.update({
            id: '/new-org',path: '/new-org',getParentRoute: () => DashboardOrganisationsRouteRoute
          })
const DashboardOrganisationsOrgIdRouteRoute = DashboardOrganisationsOrgIdRouteRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => DashboardOrganisationsRouteRoute
          })
const DashboardIvrNewIvrRoute = DashboardIvrNewIvrRouteImport.update({
            id: '/new-ivr',path: '/new-ivr',getParentRoute: () => DashboardIvrRouteRoute
          })
const DashboardIvrIvrIdRouteRoute = DashboardIvrIvrIdRouteRouteImport.update({
            id: '/$ivrId',path: '/$ivrId',getParentRoute: () => DashboardIvrRouteRoute
          })
const DashboardEmailsSystemRouteRoute = DashboardEmailsSystemRouteRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => DashboardEmailsRouteRoute
          })
const DashboardEmailsOrganisationsRouteRoute = DashboardEmailsOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardEmailsRouteRoute
          })
const DashboardCallscreeningSystemRoute = DashboardCallscreeningSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardCallscreeningQueuesRouteRoute = DashboardCallscreeningQueuesRouteRouteImport.update({
            id: '/queues',path: '/queues',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardCallscreeningOrganisationsRouteRoute = DashboardCallscreeningOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardCallscreeningRouteRoute
          })
const DashboardBusinessDirectoryTypesRouteRoute = DashboardBusinessDirectoryTypesRouteRouteImport.update({
            id: '/types',path: '/types',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardBusinessDirectoryCategoriesRouteRoute = DashboardBusinessDirectoryCategoriesRouteRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardBusinessDirectoryBusinessesRouteRoute = DashboardBusinessDirectoryBusinessesRouteRouteImport.update({
            id: '/businesses',path: '/businesses',getParentRoute: () => DashboardBusinessDirectoryRouteRoute
          })
const DashboardAdministratorsProfilesRouteRoute = DashboardAdministratorsProfilesRouteRouteImport.update({
            id: '/profiles',path: '/profiles',getParentRoute: () => DashboardAdministratorsRouteRoute
          })
const DashboardAdministratorsAccountsRouteRoute = DashboardAdministratorsAccountsRouteRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => DashboardAdministratorsRouteRoute
          })
const DashboardQueuesQueueIdSettingsRoute = DashboardQueuesQueueIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdEditRoute = DashboardQueuesQueueIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdCallScreeningRoute = DashboardQueuesQueueIdCallScreeningRouteImport.update({
            id: '/call-screening',path: '/call-screening',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueuesQueueIdAgentsRoute = DashboardQueuesQueueIdAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardQueuesQueueIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdQueuesRoute = DashboardQueueGroupsQueueGroupIdQueuesRouteImport.update({
            id: '/queues',path: '/queues',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdEditRoute = DashboardQueueGroupsQueueGroupIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardQueueGroupsQueueGroupIdAgentsRoute = DashboardQueueGroupsQueueGroupIdAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardQueueGroupsQueueGroupIdRouteRoute
          })
const DashboardOrganisationsOrgIdRenameRoute = DashboardOrganisationsOrgIdRenameRouteImport.update({
            id: '/rename',path: '/rename',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdPredefinedTextsRoute = DashboardOrganisationsOrgIdPredefinedTextsRouteImport.update({
            id: '/predefined-texts',path: '/predefined-texts',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdUsersRouteRoute = DashboardOrganisationsOrgIdUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdUserLabelsRouteRoute = DashboardOrganisationsOrgIdUserLabelsRouteRouteImport.update({
            id: '/user-labels',path: '/user-labels',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdSettingsRouteRoute = DashboardOrganisationsOrgIdSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdContactListRouteRoute = DashboardOrganisationsOrgIdContactListRouteRouteImport.update({
            id: '/contact-list',path: '/contact-list',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdCallScreeningRouteRoute = DashboardOrganisationsOrgIdCallScreeningRouteRouteImport.update({
            id: '/call-screening',path: '/call-screening',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardIvrIvrIdIndexRoute = DashboardIvrIvrIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardIvrIvrIdRouteRoute
          })
const DashboardEmailsSystemIndexRoute = DashboardEmailsSystemIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardEmailsSystemRouteRoute
          })
const DashboardEmailsSystemNewEmailRoute = DashboardEmailsSystemNewEmailRouteImport.update({
            id: '/new-email',path: '/new-email',getParentRoute: () => DashboardEmailsSystemRouteRoute
          })
const DashboardEmailsOrganisationsNewEmailRoute = DashboardEmailsOrganisationsNewEmailRouteImport.update({
            id: '/new-email',path: '/new-email',getParentRoute: () => DashboardEmailsOrganisationsRouteRoute
          })
const DashboardEmailsOrganisationsOrgIdRouteRoute = DashboardEmailsOrganisationsOrgIdRouteRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => DashboardEmailsOrganisationsRouteRoute
          })
const DashboardCallscreeningQueuesQueueIdRoute = DashboardCallscreeningQueuesQueueIdRouteImport.update({
            id: '/$queueId',path: '/$queueId',getParentRoute: () => DashboardCallscreeningQueuesRouteRoute
          })
const DashboardCallscreeningOrganisationsOrgIdRoute = DashboardCallscreeningOrganisationsOrgIdRouteImport.update({
            id: '/$orgId',path: '/$orgId',getParentRoute: () => DashboardCallscreeningOrganisationsRouteRoute
          })
const DashboardBusinessDirectoryTypesIndexRoute = DashboardBusinessDirectoryTypesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardBusinessDirectoryTypesRouteRoute
          })
const DashboardBusinessDirectoryCategoriesIndexRoute = DashboardBusinessDirectoryCategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardBusinessDirectoryCategoriesRouteRoute
          })
const DashboardBusinessDirectoryBusinessesIndexRoute = DashboardBusinessDirectoryBusinessesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardBusinessDirectoryBusinessesRouteRoute
          })
const DashboardBusinessDirectoryBusinessesRouteNewRoute = DashboardBusinessDirectoryBusinessesRouteNewRouteImport.update({
            id: '/route-new',path: '/route-new',getParentRoute: () => DashboardBusinessDirectoryBusinessesRouteRoute
          })
const DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute = DashboardBusinessDirectoryBusinessesOrganisationsRouteRouteImport.update({
            id: '/organisations',path: '/organisations',getParentRoute: () => DashboardBusinessDirectoryBusinessesRouteRoute
          })
const DashboardOrganisationsOrgIdEmailsIndexRoute = DashboardOrganisationsOrgIdEmailsIndexRouteImport.update({
            id: '/emails/',path: '/emails/',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardOrganisationsOrgIdEmailsNewEmailRoute = DashboardOrganisationsOrgIdEmailsNewEmailRouteImport.update({
            id: '/emails/new-email',path: '/emails/new-email',getParentRoute: () => DashboardOrganisationsOrgIdRouteRoute
          })
const DashboardEmailsOrganisationsOrgIdIndexRoute = DashboardEmailsOrganisationsOrgIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardEmailsOrganisationsOrgIdRouteRoute
          })
const DashboardEmailsOrganisationsOrgIdNewEmailRoute = DashboardEmailsOrganisationsOrgIdNewEmailRouteImport.update({
            id: '/new-email',path: '/new-email',getParentRoute: () => DashboardEmailsOrganisationsOrgIdRouteRoute
          })





const DashboardAdministratorsRouteRouteChildren = {
  DashboardAdministratorsAccountsRouteRoute: DashboardAdministratorsAccountsRouteRoute,DashboardAdministratorsProfilesRouteRoute: DashboardAdministratorsProfilesRouteRoute
}

const DashboardAdministratorsRouteRouteWithChildren = DashboardAdministratorsRouteRoute._addFileChildren(DashboardAdministratorsRouteRouteChildren)




const DashboardBusinessDirectoryBusinessesRouteRouteChildren = {
  DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute: DashboardBusinessDirectoryBusinessesOrganisationsRouteRoute,DashboardBusinessDirectoryBusinessesRouteNewRoute: DashboardBusinessDirectoryBusinessesRouteNewRoute,DashboardBusinessDirectoryBusinessesIndexRoute: DashboardBusinessDirectoryBusinessesIndexRoute
}

const DashboardBusinessDirectoryBusinessesRouteRouteWithChildren = DashboardBusinessDirectoryBusinessesRouteRoute._addFileChildren(DashboardBusinessDirectoryBusinessesRouteRouteChildren)




const DashboardBusinessDirectoryCategoriesRouteRouteChildren = {
  DashboardBusinessDirectoryCategoriesIndexRoute: DashboardBusinessDirectoryCategoriesIndexRoute
}

const DashboardBusinessDirectoryCategoriesRouteRouteWithChildren = DashboardBusinessDirectoryCategoriesRouteRoute._addFileChildren(DashboardBusinessDirectoryCategoriesRouteRouteChildren)




const DashboardBusinessDirectoryTypesRouteRouteChildren = {
  DashboardBusinessDirectoryTypesIndexRoute: DashboardBusinessDirectoryTypesIndexRoute
}

const DashboardBusinessDirectoryTypesRouteRouteWithChildren = DashboardBusinessDirectoryTypesRouteRoute._addFileChildren(DashboardBusinessDirectoryTypesRouteRouteChildren)



const DashboardBusinessDirectoryRouteRouteChildren = {
  DashboardBusinessDirectoryBusinessesRouteRoute: DashboardBusinessDirectoryBusinessesRouteRouteWithChildren,DashboardBusinessDirectoryCategoriesRouteRoute: DashboardBusinessDirectoryCategoriesRouteRouteWithChildren,DashboardBusinessDirectoryTypesRouteRoute: DashboardBusinessDirectoryTypesRouteRouteWithChildren
}

const DashboardBusinessDirectoryRouteRouteWithChildren = DashboardBusinessDirectoryRouteRoute._addFileChildren(DashboardBusinessDirectoryRouteRouteChildren)




const DashboardCallscreeningOrganisationsRouteRouteChildren = {
  DashboardCallscreeningOrganisationsOrgIdRoute: DashboardCallscreeningOrganisationsOrgIdRoute
}

const DashboardCallscreeningOrganisationsRouteRouteWithChildren = DashboardCallscreeningOrganisationsRouteRoute._addFileChildren(DashboardCallscreeningOrganisationsRouteRouteChildren)




const DashboardCallscreeningQueuesRouteRouteChildren = {
  DashboardCallscreeningQueuesQueueIdRoute: DashboardCallscreeningQueuesQueueIdRoute
}

const DashboardCallscreeningQueuesRouteRouteWithChildren = DashboardCallscreeningQueuesRouteRoute._addFileChildren(DashboardCallscreeningQueuesRouteRouteChildren)



const DashboardCallscreeningRouteRouteChildren = {
  DashboardCallscreeningOrganisationsRouteRoute: DashboardCallscreeningOrganisationsRouteRouteWithChildren,DashboardCallscreeningQueuesRouteRoute: DashboardCallscreeningQueuesRouteRouteWithChildren,DashboardCallscreeningSystemRoute: DashboardCallscreeningSystemRoute
}

const DashboardCallscreeningRouteRouteWithChildren = DashboardCallscreeningRouteRoute._addFileChildren(DashboardCallscreeningRouteRouteChildren)




const DashboardEmailsOrganisationsOrgIdRouteRouteChildren = {
  DashboardEmailsOrganisationsOrgIdNewEmailRoute: DashboardEmailsOrganisationsOrgIdNewEmailRoute,DashboardEmailsOrganisationsOrgIdIndexRoute: DashboardEmailsOrganisationsOrgIdIndexRoute
}

const DashboardEmailsOrganisationsOrgIdRouteRouteWithChildren = DashboardEmailsOrganisationsOrgIdRouteRoute._addFileChildren(DashboardEmailsOrganisationsOrgIdRouteRouteChildren)



const DashboardEmailsOrganisationsRouteRouteChildren = {
  DashboardEmailsOrganisationsOrgIdRouteRoute: DashboardEmailsOrganisationsOrgIdRouteRouteWithChildren,DashboardEmailsOrganisationsNewEmailRoute: DashboardEmailsOrganisationsNewEmailRoute
}

const DashboardEmailsOrganisationsRouteRouteWithChildren = DashboardEmailsOrganisationsRouteRoute._addFileChildren(DashboardEmailsOrganisationsRouteRouteChildren)




const DashboardEmailsSystemRouteRouteChildren = {
  DashboardEmailsSystemNewEmailRoute: DashboardEmailsSystemNewEmailRoute,DashboardEmailsSystemIndexRoute: DashboardEmailsSystemIndexRoute
}

const DashboardEmailsSystemRouteRouteWithChildren = DashboardEmailsSystemRouteRoute._addFileChildren(DashboardEmailsSystemRouteRouteChildren)



const DashboardEmailsRouteRouteChildren = {
  DashboardEmailsOrganisationsRouteRoute: DashboardEmailsOrganisationsRouteRouteWithChildren,DashboardEmailsSystemRouteRoute: DashboardEmailsSystemRouteRouteWithChildren
}

const DashboardEmailsRouteRouteWithChildren = DashboardEmailsRouteRoute._addFileChildren(DashboardEmailsRouteRouteChildren)




const DashboardIvrIvrIdRouteRouteChildren = {
  DashboardIvrIvrIdIndexRoute: DashboardIvrIvrIdIndexRoute
}

const DashboardIvrIvrIdRouteRouteWithChildren = DashboardIvrIvrIdRouteRoute._addFileChildren(DashboardIvrIvrIdRouteRouteChildren)



const DashboardIvrRouteRouteChildren = {
  DashboardIvrIvrIdRouteRoute: DashboardIvrIvrIdRouteRouteWithChildren,DashboardIvrNewIvrRoute: DashboardIvrNewIvrRoute
}

const DashboardIvrRouteRouteWithChildren = DashboardIvrRouteRoute._addFileChildren(DashboardIvrRouteRouteChildren)




const DashboardOrganisationsOrgIdRouteRouteChildren = {
  DashboardOrganisationsOrgIdCallScreeningRouteRoute: DashboardOrganisationsOrgIdCallScreeningRouteRoute,DashboardOrganisationsOrgIdContactListRouteRoute: DashboardOrganisationsOrgIdContactListRouteRoute,DashboardOrganisationsOrgIdSettingsRouteRoute: DashboardOrganisationsOrgIdSettingsRouteRoute,DashboardOrganisationsOrgIdUserLabelsRouteRoute: DashboardOrganisationsOrgIdUserLabelsRouteRoute,DashboardOrganisationsOrgIdUsersRouteRoute: DashboardOrganisationsOrgIdUsersRouteRoute,DashboardOrganisationsOrgIdPredefinedTextsRoute: DashboardOrganisationsOrgIdPredefinedTextsRoute,DashboardOrganisationsOrgIdRenameRoute: DashboardOrganisationsOrgIdRenameRoute,DashboardOrganisationsOrgIdEmailsNewEmailRoute: DashboardOrganisationsOrgIdEmailsNewEmailRoute,DashboardOrganisationsOrgIdEmailsIndexRoute: DashboardOrganisationsOrgIdEmailsIndexRoute
}

const DashboardOrganisationsOrgIdRouteRouteWithChildren = DashboardOrganisationsOrgIdRouteRoute._addFileChildren(DashboardOrganisationsOrgIdRouteRouteChildren)



const DashboardOrganisationsRouteRouteChildren = {
  DashboardOrganisationsOrgIdRouteRoute: DashboardOrganisationsOrgIdRouteRouteWithChildren,DashboardOrganisationsNewOrgRoute: DashboardOrganisationsNewOrgRoute
}

const DashboardOrganisationsRouteRouteWithChildren = DashboardOrganisationsRouteRoute._addFileChildren(DashboardOrganisationsRouteRouteChildren)




const DashboardQueueGroupsQueueGroupIdRouteRouteChildren = {
  DashboardQueueGroupsQueueGroupIdAgentsRoute: DashboardQueueGroupsQueueGroupIdAgentsRoute,DashboardQueueGroupsQueueGroupIdEditRoute: DashboardQueueGroupsQueueGroupIdEditRoute,DashboardQueueGroupsQueueGroupIdQueuesRoute: DashboardQueueGroupsQueueGroupIdQueuesRoute
}

const DashboardQueueGroupsQueueGroupIdRouteRouteWithChildren = DashboardQueueGroupsQueueGroupIdRouteRoute._addFileChildren(DashboardQueueGroupsQueueGroupIdRouteRouteChildren)



const DashboardQueueGroupsRouteRouteChildren = {
  DashboardQueueGroupsQueueGroupIdRouteRoute: DashboardQueueGroupsQueueGroupIdRouteRouteWithChildren,DashboardQueueGroupsNewGroupRoute: DashboardQueueGroupsNewGroupRoute
}

const DashboardQueueGroupsRouteRouteWithChildren = DashboardQueueGroupsRouteRoute._addFileChildren(DashboardQueueGroupsRouteRouteChildren)




const DashboardQueuesQueueIdRouteRouteChildren = {
  DashboardQueuesQueueIdAgentsRoute: DashboardQueuesQueueIdAgentsRoute,DashboardQueuesQueueIdCallScreeningRoute: DashboardQueuesQueueIdCallScreeningRoute,DashboardQueuesQueueIdEditRoute: DashboardQueuesQueueIdEditRoute,DashboardQueuesQueueIdSettingsRoute: DashboardQueuesQueueIdSettingsRoute
}

const DashboardQueuesQueueIdRouteRouteWithChildren = DashboardQueuesQueueIdRouteRoute._addFileChildren(DashboardQueuesQueueIdRouteRouteChildren)



const DashboardQueuesRouteRouteChildren = {
  DashboardQueuesQueueIdRouteRoute: DashboardQueuesQueueIdRouteRouteWithChildren,DashboardQueuesNewQueueRoute: DashboardQueuesNewQueueRoute
}

const DashboardQueuesRouteRouteWithChildren = DashboardQueuesRouteRoute._addFileChildren(DashboardQueuesRouteRouteChildren)



const DashboardRouteRouteChildren = {
  DashboardAdministratorsRouteRoute: DashboardAdministratorsRouteRouteWithChildren,DashboardBusinessDirectoryRouteRoute: DashboardBusinessDirectoryRouteRouteWithChildren,DashboardCallscreeningRouteRoute: DashboardCallscreeningRouteRouteWithChildren,DashboardClientManagementRouteRoute: DashboardClientManagementRouteRoute,DashboardDivergencesRouteRoute: DashboardDivergencesRouteRoute,DashboardEmailsRouteRoute: DashboardEmailsRouteRouteWithChildren,DashboardGatewaysRouteRoute: DashboardGatewaysRouteRoute,DashboardIvrRouteRoute: DashboardIvrRouteRouteWithChildren,DashboardLicencesRouteRoute: DashboardLicencesRouteRoute,DashboardOrganisationsRouteRoute: DashboardOrganisationsRouteRouteWithChildren,DashboardQueueGroupsRouteRoute: DashboardQueueGroupsRouteRouteWithChildren,DashboardQueuesRouteRoute: DashboardQueuesRouteRouteWithChildren,DashboardSettingsRouteRoute: DashboardSettingsRouteRoute,DashboardUserLabelsRouteRoute: DashboardUserLabelsRouteRoute,DashboardUsersRouteRoute: DashboardUsersRouteRoute,Dashboard401Route: Dashboard401Route
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRouteRoute: DashboardRouteRouteWithChildren,PasswordExpiredRoute: PasswordExpiredRoute,AuthLoginRoute: AuthLoginRoute,AuthLogoutRoute: AuthLogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)